import React from 'react';
import PropTypes from 'prop-types';

const CancelLogin = ({ action, requireWinz, backToSelectionBtnText, theme }) => {
  return (
    <div className="form-group">
      <button
        className={`form-control btn btn-secondary ${theme.buttonClass || ''}`}
        onClick={action}
        type="button"
      >
        {!requireWinz && (
          <>
            <span className="icon-chevron-circle-left"></span>&nbsp;
          </>
        )}
        {backToSelectionBtnText}
      </button>
    </div>
  );
};

CancelLogin.propTypes = {
  action: PropTypes.func.isRequired,
  requireWinz: PropTypes.bool,
  backToSelectionBtnText: PropTypes.string.isRequired,
  theme: PropTypes.object
};

export default CancelLogin;
